import { action } from 'satcheljs';

/**
 * Action which starts the search session and initialises the store to make a valid service call
 * @param onCompletion optional which will be invoked by the listeners on completion of the action
 */
export default action('startSearchSession', function startSearchSession(onCompletion?: () => any) {
    return { onCompletion };
});
